exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reference-container {\n    display: grid;\n    grid-template-columns: -webkit-min-content auto;\n    grid-template-columns: min-content auto;\n    grid-column-gap: 10px;\n    grid-auto-flow: row;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/output/references-table/references-table.component.css
// module id = ./src/app/components/output/references-table/references-table.component.css
// module chunks = main